export const RN_COMPETENCY_ITEMS = [
    // Header
    {
        id: 0,
        type: 'header',
        title: "Clinical Competency Program",
        subtitle: "INITIAL COMPETENCY ASSESSMENT SKILLS CHECKLIST—REGISTERED NURSE",
        company: "INFINITE HOME HEALTH, INC"
    },

    // Page 1: Administrative/Documentation
    {
        id: 1,
        type: 'section',
        title: "A. Demonstrates ability to process paperwork and associated functions necessary to facilitate:",
        competencies: [
            {
                category: "1. Admission to organization",
                items: [
                    "a. Initiates assessment form",
                    "b. Initiates care plan based on assessment",
                    "c. Knowledge of nursing process",
                    "d. Health history/physical exam",
                    "e. Development of problem list and care planning",
                    "f. Conducts complete initial evaluation"
                ]
            },
            {
                category: "2. Transfer of patient"
            },
            {
                category: "3. Care coordination/discharge planning",
                items: [
                    "a. Care planning",
                    "b. Case conference",
                    "c. 60 day summary",
                    "d. Case management",
                    "e. Adheres to POC",
                    "f. Reports and documents key information to physician, DC planner, Case Manager, pharmacist, supervisor",
                    "g. Coordinates community resources"
                ]
            },
            {
                category: "4. Documentation",
                items: [
                    "a. Medicare guidelines for documentation",
                    "b. Corrections to the clinical record",
                    "c. Accident/incident reports",
                    "d. Clinical notes, flow charts"
                ]
            },
            {
                category: "5. Other",
                items: [
                    "a. Supervision of ancillary personnel",
                    "b. Supply requisition and management"
                ]
            }
        ]
    },

    // Page 2: Review of Systems - Pulmonary & Cardiovascular
    {
        id: 2,
        type: 'section',
        title: "B. Review of Systems: Demonstrates ability to obtain and document appropriate age specific history/assessment for patients in the following categories:",
        competencies: [
            {
                category: "1. Pulmonary System",
                items: [
                    "a. Pulmonary Assessment",
                    "b. Tracheostomy care",
                    "c. Oxygen administration",
                    "d. Pharyngeal suction",
                    "e. Use of oral/nasal inhalers",
                    "f. Oximeter",
                    "g. CPAP",
                    "h. Oxygen mask, nasal cannula, concentrator, portable oxygen",
                    "i. Airway insertion",
                    "j. SVN/Nebulizer treatment",
                    "k. Home ventilator management",
                    "l. Foreign body airway obstruction",
                    "m. Breathing exercises/incentive spirometry",
                    "n. Other"
                ]
            },
            {
                category: "2. Cardiovascular System",
                items: [
                    "a. Cardiovascular assessment",
                    "b. Pulses (apical, radical, femoral, pedal)",
                    "c. Edema assessment and management",
                    "d. Supine and orthostatic blood pressure",
                    "e. NTG use, inhaler use",
                    "f. CPR",
                    "g. Energy conservation techniques",
                    "h. Other"
                ]
            }
        ]
    },

    // Page 3: Neurologic & Gastrointestinal Systems
    {
        id: 3,
        type: 'section',
        title: "B. Review of Systems (continued):",
        competencies: [
            {
                category: "3. Neurologic System",
                items: [
                    "a. Neurologic assessment",
                    "b. Aphasia care",
                    "c. Mental status exam",
                    "d. Seizure precautions",
                    "e. Spinal cord injuries care",
                    "f. Head injury care",
                    "g. Other"
                ]
            },
            {
                category: "4. Gastrointestinal System",
                items: [
                    "a. Gastrointestinal assessment",
                    "b. NG tube insertion/care",
                    "c. Jejunostomy tube care",
                    "d. Gastrostomy tube care",
                    "e. Enteral feedings",
                    "f. Suction machine(s)",
                    "g. Ostomy care",
                    "h. Dysphagia precautions",
                    "i. Impaction removal",
                    "j. Enema",
                    "k. Bowel training"
                ]
            }
        ]
    },

    // Page 4: Genitourinary & Integumentary Systems
    {
        id: 4,
        type: 'section',
        title: "B. Review of Systems (continued):",
        competencies: [
            {
                category: "5. Genitourinary System",
                items: [
                    "a. GU assessment",
                    "b. Urinary catheterization insertion and care (male and female)",
                    "c. Irrigation of catheters",
                    "d. Obtaining specimens",
                    "e. Removal of urinary catheter",
                    "f. Care of supra-pubic catheter",
                    "g. Care of urostomy",
                    "h. Bladder training",
                    "i. Nephrostomy tubes",
                    "j. Knowledge of types of catheters and indications for use (straight, indwelling, condom)",
                    "k. Ileostomy care",
                    "l. Incontinence care",
                    "m. GU post op care",
                    "n. Other"
                ]
            },
            {
                category: "6. Integumentary/Wounds/Dressings",
                items: [
                    "a. Assessment of skin/wound",
                    "b. Measurement of wounds",
                    "c. Wound irrigation",
                    "d. Wet to dry dressing(s)",
                    {
                        text: "e. Decubitis care:",
                        subItems: [
                            "1. Assessment and staging",
                            "2. Prevention",
                            "3. Various treatments (hydrocollid, calcium alginate, transparent films)",
                            "4. Documentation/pictures"
                        ]
                    },
                    "f. Ace wrap, cast care, compresses",
                    "g. Hemovac",
                    "h. Sterile dressing change",
                    "i. Suture/staple removal"
                ]
            }
        ]
    },

    // Page 5: Musculoskeletal & Pain Management
    {
        id: 5,
        type: 'section',
        title: "B. Review of Systems (continued):",
        competencies: [
            {
                category: "7. Musculoskeletal System",
                items: [
                    "a. Assessment",
                    "b. Range of motion (ROM)",
                    "c. TED hose",
                    "d. Total knee care",
                    "e. Total hip care",
                    "f. Cast assessment and care",
                    {
                        text: "g. Devices:",
                        subItems: [
                            "1. Walker",
                            "2. Wheelchair",
                            "3. Transfer board",
                            "4. Hoyer lift"
                        ]
                    },
                    "h. Pain assessment",
                    "i. Transfers",
                    "j. Other"
                ]
            },
            {
                category: "8. Pain assessment and management:",
                items: [
                    "a. Conducts pain evaluation which includes location, onset, intensity, duration, alleviating factors",
                    "b. Utilizes a pain rating scale to collect data",
                    "c. Knowledgeable about types of pain (neuropathic, visceral, bone, smooth muscle, psychologic)",
                    "d. Knowledgeable about drug therapies indication and dosing",
                    {
                        text: "e. Pharmacologic Methods:",
                        subItems: [
                            "1. NSAIDS",
                            "2. Steroids",
                            "3. Benzodiazepines",
                            "4. Tricyclic antidepressants",
                            "5. Anticonvulsants",
                            "6. Narcotics",
                            "7. Other"
                        ]
                    },
                    {
                        text: "f. Non-pharmacologic methods:",
                        subItems: [
                            "1. Relaxation (guided imagery, meditation, massage)",
                            "2. Psychologic (biofeedback, therapy)",
                            "3. Neurologic (TENS)",
                            "4. Ice/heat"
                        ]
                    },
                    {
                        text: "g. Patient/family teaching:",
                        subItems: [
                            "1. Drug use, side effects",
                            "2. Management of constipation",
                            "3. Addiction vs. tolerance",
                            "4. Other"
                        ]
                    }
                ]
            }
        ]
    },

    // Page 6: Metabolic, Behavioral & Miscellaneous
    {
        id: 6,
        type: 'section',
        title: "B. Review of Systems (continued):",
        competencies: [
            {
                category: "9. Metabolic:",
                items: [
                    "a. Assessment",
                    {
                        text: "b. Diabetic assessment and teaching:",
                        subItems: [
                            "1. Insulin types and teaching",
                            "2. Use, care and teaching of glucose monitoring system",
                            "3. Diet, exercise and sick-day teaching",
                            "4. Signs and symptoms of Hypo-Hyperglycemic reactions",
                            "5. Foot and skin care"
                        ]
                    },
                    "c. Coumadin therapy",
                    "d. Other"
                ]
            },
            {
                category: "10. Behavioral Assessment",
                items: [
                    "a. Psychosocial Status",
                    "b. Suicide precautions",
                    "c. Psychotropic drugs",
                    "d. Care of the demented patient",
                    "e. Other"
                ]
            },
            {
                category: "11. Miscellaneous Skills",
                items: [
                    "a. Vital signs",
                    "b. Intake and output",
                    "c. Caring for immuno-compromised patients",
                    "d. eye/ear irrigation",
                    "e. Post mortem care",
                    "f. Collection, labeling and delivering laboratory specimens (blood, urine, sputum, wound, stool)",
                    {
                        text: "g. Concepts of death and dying",
                        subItems: [
                            "1. Normal vs. abnormal",
                            "2. Cultural attitudes toward death",
                            "3. Values of patient/family",
                            "4. Denial and coping mechanisms",
                            "5. Grief and family, children and others",
                            "6. Anticipatory grief",
                            "7. Other"
                        ]
                    }
                ]
            }
        ]
    },

    // Page 7: Medication Administration & Infection Control
    {
        id: 7,
        type: 'section',
        title: "C. Medication Administration & Infection Control:",
        competencies: [
            {
                category: "C. Medication Administration: Demonstrates ability to administer, monitor and document medications for patients.",
                items: [
                    {
                        text: "1. Medication Administration Techniques",
                        subItems: [
                            "a. Oral",
                            "b. Intramuscular",
                            "c. Intravenous-bolus/push",
                            "d. Subcutaneous",
                            "e. Total Parenteral Nutrition",
                            "f. Suppositories",
                            "g. Ear, eye, nose drops",
                            "h. Heparin administration",
                            "i. Insulin administration, site rotation",
                            "j. Assessment for side effects, adverse reactions, therapeutic response"
                        ]
                    },
                    {
                        text: "2. Intravenous Therapy:",
                        subItems: [
                            {
                                text: "a. Technique and care of:",
                                subSubItems: [
                                    "1. Venipuncture",
                                    "2. Butterfly",
                                    "3. Over the needle catheter",
                                    "4. Regulation of IV flow rate, use of infusion pumps"
                                ]
                            },
                            "b. Other"
                        ]
                    },
                    {
                        text: "3. Central Venous Access Devices:",
                        subItems: [
                            "a. Drawing blood from",
                            "b. Site care",
                            "c. Flushing",
                            "d. Cap change",
                            "e. Needleless system",
                            "f. Other"
                        ]
                    }
                ]
            },
            {
                category: "D. Infection Control:",
                items: [
                    "1. Hand washing technique",
                    "2. Aseptic technique",
                    "3. Proper bag technique",
                    "4. Safe needle technique",
                    "5. Personal protective equipment",
                    "6. Exposure control plan",
                    "7. TB exposure control plan",
                    "8. Reporting of infections for patient and personnel",
                    "9. Standard precautions"
                ]
            }
        ]
    },

    // Page 8: Equipment, Safety & Patient Education
    {
        id: 8,
        type: 'section',
        title: "E. Equipment, Safety & Patient Education:",
        competencies: [
            {
                category: "E. Equipment:",
                items: [
                    {
                        text: "1. Displays knowledge of the following:",
                        subItems: [
                            "a. Electric bed",
                            "b. Special beds",
                            "c. Alternating pressure mattress",
                            "d. Infusion pumps",
                            "e. Ambulatory infusion devices"
                        ]
                    },
                    {
                        text: "2. Home Glucose Monitoring:",
                        subItems: [
                            "a. Verbalizes purpose of test",
                            "b. Specimen collection",
                            "c. Instrument calibration",
                            "d. Quality control process",
                            "e. Test correctly performed and interpreted"
                        ]
                    },
                    "3. Other"
                ]
            },
            {
                category: "F. Safety:",
                items: [
                    "1. Restraints, indications and policy",
                    "2. Fire extinguishers",
                    "3. Emergency preparedness",
                    "4. Hazardous materials",
                    "5. Assessment of patient safety risks and home safety"
                ]
            },
            {
                category: "G. Patient Education:",
                items: [
                    "1. Determine patient and family learning needs",
                    "2. Sets measurable objectives",
                    "3. Develops/implements teaching plan",
                    "4. Evaluates effectiveness of teaching",
                    "5. Revises teaching plan based on patient needs",
                    "6. Documents response to teaching",
                    {
                        text: "7. Provides instruction in the following:",
                        subItems: [
                            "a. Emergency care",
                            "b. Diet and nutrition",
                            {
                                text: "c. Medications",
                                subSubItems: [
                                    "1. Route, dosage, frequency, side effects, adverse reactions, safe storage, labeling, indications, drug/food interactions, home monitoring program, therapeutic blood levels"
                                ]
                            }
                        ]
                    },
                    "8. Provides instruction about advance directives and patient rights",
                    "9. Other"
                ]
            }
        ]
    },

    // Page 9: Comments & Signatures
    {
        id: 9,
        type: 'signature',
        title: "Comments & Signatures",
        fields: [
            { label: "Employee Signature", name: "employeeSignature" },
            { label: "Date", name: "employeeDate", inputType: "date" },
            { label: "Supervisor Signature", name: "supervisorSignature" },
            { label: "Date", name: "supervisorDate", inputType: "date" },
            { label: "Preceptor(s)", name: "preceptor1Signature" },
            { label: "Date", name: "preceptor1Date", inputType: "date" },
            { label: "Preceptor(s)", name: "preceptor2Signature" },
            { label: "Date", name: "preceptor2Date", inputType: "date" },
            { label: "Preceptor(s)", name: "preceptor3Signature" },
            { label: "Date", name: "preceptor3Date", inputType: "date" }
        ]
    },

    // Footer
    {
        id: 10,
        type: 'footer',
        text: "Joint Commission Home Health Human Resource/revised October 2012",
        copyright: "© 1995 The Corridor Group, Inc."
    }
];

export const RN_JOB_DESCRIPTION_ITEMS = [
    // 0: Job Header
    {
        id: 0,
        type: 'header',
        title: "Job Description",
        position: "Registered Nurse / Case Manager",
        reportsTo: "Clinical Supervisor"
    },
    // 1: Qualifications Section
    {
        id: 1,
        type: 'section',
        title: "QUALIFICATIONS:",
        list: [
            "Is currently a licensed Registered Nurse in the State of California.",
            "Has at least one-year experience as a professional nurse.",
            "Has excellent clinical judgment, knowledge of current nursing practices, observation, and communication skills.",
            "Current CPR Certification.",
            "Current and satisfactory report on pre-employment physical examination including Mantoux TB Test or chest X-ray as required by Agency policies and procedures.",
            "Able to walk, bend, stoop, and lift objects weighing up to 25 lbs.",
            "Is fluent in English.",
            "Is self-directed and able to work with little supervision and has good organizational skills.",
            "Must be a licensed driver with an automobile that is insured in accordance with state and/or organizational requirements and is in good working order.",
            "Is able to use professional judgment in reporting and seeking assistance from both peers and supervisors."
        ]
    },
    // 2: Position Summary
    {
        id: 2,
        type: 'text_block',
        title: "POSITION SUMMARY:",
        text: "The Case Manager will use the nursing process to assess and manage the medical needs of the patient. The Case Manager identifies other disciplines needed to maximize the patient's progress toward goals. The Case Manager will be the patient's advocate and will be in communication with the primary MD and the Clinical Supervisor, as the patient's condition requires."
    },
    // 3: Essential Duties and Responsibilities
    {
        id: 3,
        type: 'section',
        title: "ESSENTIAL DUTIES AND RESPONSIBILITIES:",
        text: "The following is representation of the major duties and responsibilities of this position. The Agency will make reasonable accommodations to allow otherwise qualified applicants with disabilities to perform essential functions.",
        duties: [
            "Assesses all patients initially, choosing appropriate parameters for measurement and observation related to the patient's medical history/disease process, nursing assessment, functional limitations and the Plan of Care.",
            "Initiates the plan of care.",
            "Provides the ongoing periodic assessment of the patient, monitors patients for all important parameters on each visit; utilizes monitored information to progress therapy/intervention toward goals and revises the Plan of Care as needed.",
            "Notifies the patient's attending physician, dentist or podiatrist and other professional persons and responsible staff of all significant changes in the patient's condition and needs. \"Significant change\" includes those changes that suggest the need to modify or develop a plan of treatment or plan of care.",
            "Carries out the physician's orders as directed; clarifies orders.",
            "Regularly re-evaluates the patient's nursing needs.",
            "Follows current standards of clinical nursing practice with appropriate adaptations for delivering care in the home environment.",
            "Gives clear and precise explanations to the patient and family caregiver about services the Agency provides, their rights and how to exercise them while receiving services. Informs patient/PCG of the reasons for treatment and any responsibilities they may have following the treatment. Promotes participation in developing the Plan of Care to the extent they are willing and able to participate.",
            "Counsels the patient and family in meeting nursing and related needs.",
            "Assists in coordinating all services provided.",
            "Educates and instructs the patient, patient's family, or staff as required.",
            "Identifies problems for which nursing services are to be provided and selects those that can be addressed within the scope of services offered by the Agency and focuses on goals that are realistic, obtainable, measurable and patient-centered.",
            "Begins planning for discharge when treatment goals are being attained or when no longer attainable. Prepares the patient/PGC for discharge by clearly instructing them on the continuing treatment and health care behaviors that need to be followed after skilled services have been discontinued.",
            "Coordinates patient care and discharge planning with the physician, other members of the health care team and with community services, including referrals for continued services as needed.",
            "Provides instruction to the patient and/or caregiver regarding but not limited to medications, disease process, treatment, safety interventions, and ADL/IADL care. Incorporates patient's knowledge deficits into the teaching plan. Promotes self care and treatment independence in a positive manner that allows the patient control over aspects of his/her life that have been changed by acute and chronic illness.",
            "Maintains current knowledge and skills for documenting care meeting Regulatory and third party payer requirements. Prepares documentation and clinical/progress notes. Documents clearly and concisely, using proper terminology.",
            "Collects and completes the Outcomes Assessment Information Sets developed and mandated by HCFA. Submits data sets within the guidelines established by HCFA.",
            "Reports all events/occurrences that pose an actual or potential risk to patients or Agency personnel and completes an Incident/Accident Report as required by Agency policy when necessary.",
            "Reports/submits all other quality indicator data as required by Agency policy (i.e. glucometer logs, patient grievances, patient/employee infections, etc.).",
            "Manages all hazardous materials and wastes in a prudent and cautious manner according to Agency policy.",
            "Establishes a supportive relationship with patient and caregiver that promotes a climate for caring and for mobilizing the patient's own resources.",
            "Utilizes additional community services appropriately. Incorporates advocacy into the Care Plan by providing information or direct advocacy to obtain medical care, other health care services, equipment and supplies when necessary.",
            "Respects the patient's and family's rights and property as defined by the federal and state laws. Keeps all patient information confidential.",
            "Regularly attends and participates in scheduled case conferences, staff meetings and Agency in-services.",
            "Supervises Home Health Aides every 14 days in the home and or as required. Supervises LVNs as required. Teaches other nursing personnel.",
            "Regularly assesses own nursing skills and educational needs to meet the nursing care requirements of patients assigned for care. Upgrades professional skills and attends in-services and continuing education classes as needed.",
            "Provides those services requiring substantial and specialized nursing skills in accordance with the plan of treatment or plan of care.",
            "Will perform duties consistent with the Nursing Practice Act including the Standards of Competent Performance, Title 16, Chapter 14, 1443.5 of the California Code of Regulation.",
            "Conforms to all Agency policies and procedures."
        ]
    },
    // 4: Supply Protocol Section
    // {
    //     id: 4,
    //     type: 'protocol_section',
    //     title: "ORDERING SUPPLIES + SUPERVISORY VISITS",
    //     email: "SHEAVA@INFINITEHHA.COM",
    //     subject_line: "LAST NAME, FIRST NAME, SUPPLY ORDER) EX: DOE, JOHN SUPPLY",
    //     content: [
    //         {
    //             label: "Medicare Patients",
    //             text: "We supply everything for our MEDICARE patients."
    //         },
    //         {
    //             label: "Kaiser Patients",
    //             text: "Kaiser covers specialty supplies for their patients. Basic supplies must be picked up from the office.",
    //             basic_supplies: ["GLOVES", "NORMAL SALINE", "GAUZE", "KERLIX", "BETADINE", "COBAN", "STERILE WATER", "TAPE"],
    //             specialty_supplies: ["AQUACEL", "AQUACEL AG", "MEPILEX", "WOUND CLEANSER", "PROFORE", "COFLEX", "CATHETERS", "INSERTION KITS", "PICC LINE DRESSING CHANGES, ETC."]
    //         }
    //     ],
    //     rules: [
    //         "Email supply orders 4-6 days prior to the patient running out of supplies.",
    //         "Request enough for TWO WEEKS only. Kaiser will approve only two weeks' worth of supplies at a time, and the quantity must match the wound care and size of the wound.",
    //         "Request supplies within 1 day of your SOC visit or even prior to your SOC visit if you have confirmed with the patient that they do not have supplies.",
    //         "Patients should receive all ordered supplies within 3-5 days LATEST after they have been ordered.",
    //         "Please notify me if patients have not received supplies on time, and I can look into it or provide a delivery status."
    //     ]
    // },
    // 5: Supervisory Visits Protocol
    // {
    //     id: 5,
    //     type: 'supervisory_section',
    //     title: "SUPERVISORY VISITS",
    //     rules: [
    //         "You do not have to be there with the LVN or CHHA to do these visits.",
    //         "The requirement is to fill out the SUP section of your note showing you checked in with the patient regarding the LVN/CHHA since those two can never be on a case alone.",
    //         "If an LVN is following the patient, PLEASE DO NOT FORGET TO COORDINATE MONTHLY SUP VISITS FOR YOUR PATIENTS THAT HAVE LVNS.",
    //         "EVERY OTHER WEEK SUP VISITS FOR ALL PATIENTS WITH CHHA.",
    //         "****Please make sure that LVNs are not scheduled to see the patients on the days your SUP visits/RECERTS are due****"
    //     ]
    // },
    // 6: Signature Block
    {
        id: 6,
        type: 'signature',
        fields: [
            { label: "Employee Signature", name: "employeeSignature" },
            { label: "Date", name: "signatureDate", inputType: "date" }
        ]
    }
];
